/* eslint-disable no-unused-vars */
import React, { useContext, useMemo } from "react";
import { AppContext } from "../../../scripts/context";
import Button from "react-bootstrap/Button";
import Dropdown from "react-bootstrap/Dropdown";
import { Nav } from "react-bootstrap";
import { Link, NavLink } from "react-router-dom";
import { ConnectButton } from "@rainbow-me/rainbowkit";
import { copyToClipboard } from "../../../Helper/Helper";

// Generate unique geometric avatar based on address
const generateGeometricAvatar = (address) => {
  if (!address) return null;

  // Use address to generate consistent colors and shapes
  const hash = address
    .split("")
    .reduce((acc, char) => acc + char.charCodeAt(0), 0);

  // Generate color palette from hash
  const hue1 = (hash * 137.508) % 360;
  const hue2 = (hash * 137.508 + 120) % 360;
  const hue3 = (hash * 137.508 + 240) % 360;

  const color1 = `hsl(${hue1}, 70%, 55%)`;
  const color2 = `hsl(${hue2}, 70%, 55%)`;
  const color3 = `hsl(${hue3}, 70%, 55%)`;
  const color4 = `hsl(${hue1}, 60%, 45%)`;

  // Generate shape positions based on hash
  const shapes = [];
  const size = 40;
  const numShapes = 5 + (hash % 4); // 5-8 shapes

  for (let i = 0; i < numShapes; i++) {
    const shapeType = (hash + i * 7) % 3; // 0: triangle, 1: polygon, 2: circle
    const x = (hash + i * 13) % size;
    const y = (hash + i * 17) % size;
    const rotation = (hash + i * 23) % 360;
    const colors = [color1, color2, color3, color4];
    const color = colors[(hash + i * 11) % colors.length];

    if (shapeType === 0) {
      // Triangle
      const points = [
        [x, y],
        [x + 8 + (hash % 10), y + 12 + (hash % 8)],
        [x - 6 - (hash % 7), y + 10 + (hash % 9)],
      ];
      shapes.push(
        `<polygon points="${points
          .map((p) => p.join(","))
          .join(
            " "
          )}" fill="${color}" opacity="0.8" transform="rotate(${rotation} ${x} ${y})" />`
      );
    } else if (shapeType === 1) {
      // Hexagon/Polygon
      const sides = 6;
      const radius = 5 + (hash % 5);
      const points = [];
      for (let j = 0; j < sides; j++) {
        const angle = (j * 360) / sides + rotation;
        const px = x + radius * Math.cos((angle * Math.PI) / 180);
        const py = y + radius * Math.sin((angle * Math.PI) / 180);
        points.push([px, py]);
      }
      shapes.push(
        `<polygon points="${points
          .map((p) => p.join(","))
          .join(" ")}" fill="${color}" opacity="0.7" />`
      );
    } else {
      // Circle
      const radius = 4 + (hash % 6);
      shapes.push(
        `<circle cx="${x}" cy="${y}" r="${radius}" fill="${color}" opacity="0.75" />`
      );
    }
  }

  // Create gradient background
  const gradientId = `gradient-${hash}`;
  const svg = `
    <svg width="${size}" height="${size}" viewBox="0 0 ${size} ${size}" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="${gradientId}" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" style="stop-color:${color1};stop-opacity:1" />
          <stop offset="50%" style="stop-color:${color2};stop-opacity:1" />
          <stop offset="100%" style="stop-color:${color3};stop-opacity:1" />
        </linearGradient>
      </defs>
      <rect width="${size}" height="${size}" fill="url(#${gradientId})" />
      ${shapes.join("")}
    </svg>
  `.trim();

  return `data:image/svg+xml;base64,${btoa(svg)}`;
};

/*  This Component for Connect Wallet button | khaled Mofeed | 5/12/2022 */
export default function NavbarConnect() {
  /*  imported from context AppContext | khaled Mofeed | 5/12/2022 */
  const { userData, isToken } = useContext(AppContext) || {};
  /* This function for copy Adress To Clipboard | khaled Mofeed | 5/12/2022 */
  function copyAdressToClipboard() {
    copyToClipboard(userData?.wallet_address);
  }
  return (
    <>
      <ConnectButton.Custom>
        {({
          account,
          chain,
          openAccountModal,
          openChainModal,
          openConnectModal,
          authenticationStatus,
          mounted,
        }) => {
          const ready = mounted && authenticationStatus !== "loading";
          const connected =
            ready &&
            account &&
            chain &&
            (!authenticationStatus || authenticationStatus === "authenticated");
          return (
            <div
              {...(!ready && {
                "aria-hidden": true,
                style: {
                  opacity: 0,
                  pointerEvents: "none",
                  userSelect: "none",
                },
              })}
            >
              {(() => {
                if (!connected) {
                  return (
                    <Button
                      onClick={openConnectModal}
                      id="connect-wallet"
                      variant="outline-secondary"
                      type="button"
                      className="custom-secondary ms-3 btn px-5"
                    >
                      Sign In
                    </Button>
                  );
                }
                if (chain?.unsupported) {
                  return (
                    <Button
                      onClick={openChainModal}
                      id="connect-wallet"
                      variant="outline-secondary"
                      type="button"
                      className="custom-secondary ms-3 btn px-5 WrongNetwork "
                    >
                      Wrong network
                    </Button>
                  );
                }
                if (connected && !isToken) {
                  return (
                    <>
                      <Button
                        onClick={openAccountModal}
                        id="connect-wallet"
                        variant="outline-secondary"
                        type="button"
                        className="custom-secondary ms-3 btn px-5"
                      >
                        <img
                          src="/img/disconnectWhite.svg"
                          alt="disconnect"
                          className="disconnectImg"
                        />{" "}
                        Disconnect
                      </Button>
                    </>
                  );
                }

                const avatarSrc =
                  generateGeometricAvatar(
                    userData?.wallet_address || account?.address
                  ) || userData?.avatar;

                return (
                  <>
                    <div className="addres-info">
                      <div className="wallet-address-button-container">
                        <Dropdown>
                          <Dropdown.Toggle
                            variant="outline-secondary"
                            className="custom-secondary nav-btn"
                          >
                            <img
                              src={avatarSrc}
                              className="avatar"
                              alt="avatar"
                            />
                            <span className="d-none d-lg-block">
                              {account?.displayName}
                            </span>
                          </Dropdown.Toggle>

                          <Dropdown.Menu>
                            <Nav key="ProfileData">
                              <div className="ProfileData">
                                <h5 className="nickName">{userData?.name}</h5>
                                <p className="addressLable">
                                  {userData?.wallet_address &&
                                    userData?.wallet_address.substring(0, 10) +
                                      "..." +
                                      userData?.wallet_address.substring(
                                        userData?.wallet_address.length - 4
                                      )}
                                  <Link className="copyBtn">
                                    <img
                                      src="/img/copy.svg"
                                      onClick={copyAdressToClipboard}
                                      alt="copy"
                                    />
                                  </Link>
                                </p>
                              </div>
                            </Nav>
                            <Nav
                              // key="ProfileData"
                              onClick={openAccountModal}
                              className="pointer"
                            >
                              <div className="ProfileDataBalance">
                                <img
                                  src="/img/networkIcon.png"
                                  alt="copy"
                                  className="networkIcon"
                                />
                                <div className="ProfileDataBalanceText">
                                  <p className="LableName">Balance</p>
                                  <p className="LableBalance">
                                    {account?.displayBalance}
                                  </p>
                                </div>
                              </div>
                            </Nav>
                            <Nav
                              key="Transactions"
                              onClick={openChainModal}
                              className="pointer"
                            >
                              <div className="ProfileDataBalance border-custome">
                                {chain.iconUrl && (
                                  <img
                                    alt={chain.name ?? "Chain icon"}
                                    src={chain.iconUrl}
                                    className="networkIcon"
                                  />
                                )}
                                <div className="ProfileDataBalanceText">
                                  <p className="LableName">Network</p>
                                  <p className="LableBalance">{chain.name}</p>
                                </div>
                              </div>
                            </Nav>
                            {/* <Nav key="Profile">
                              <NavLink
                                to="/profile"
                                className="nav-link menuBottom"
                              >
                                <img
                                  src="/img/profileSvg.svg"
                                  alt="profileSvg"
                                />{" "}
                                Profile
                              </NavLink>
                            </Nav> */}
                            <Nav key="Profile" onClick={openAccountModal}>
                              <NavLink className="nav-link menuBottom">
                                <img
                                  src="/img/disconnect.svg"
                                  alt="disconnect"
                                />{" "}
                                Disconnect
                              </NavLink>
                            </Nav>
                          </Dropdown.Menu>
                        </Dropdown>
                      </div>
                    </div>
                  </>
                );
              })()}
            </div>
          );
        }}
      </ConnectButton.Custom>
    </>
  );
}
